import Context from "../context/Context";

let nextId = 0;

export default class Rdx {

  static store: any;

  static Keys = {
    TEST1: "TEST1"
  };

  static Types = {
    RESET_ALL: "RESET_ALL",
    SET_VALUE: "SET_VALUE"
  };

  static Actions = {

    resetAll: () => ({
      type: Rdx.Types.RESET_ALL
    }),

    setValue: (key: string, value: any) => ({
      type: Rdx.Types.SET_VALUE,
      payload: {key: key, value: value}
    })

  };

  static Selectors = {

    getValue: (state: any, section:string, key:string) => {
      if (state[section]) return state[section][key];
    }

  }

  static Reducers = {

    rdx: (state: any = {}, action: any) => {
      let newState: any;
      switch (action.type) {
        case Rdx.Types.RESET_ALL:
          newState = Object.assign({}, Rdx.getInitialState().rdx);
          Object.keys(state).forEach(k => {
            if (k && k.indexOf("cfg-") === 0) {
              newState[k] = state[k];
            }
          });
          return newState;
        case Rdx.Types.SET_VALUE:
          newState = Object.assign({}, state);
          newState[action.payload.key] = action.payload.value;
          return newState;
        default:
          return state
      }
    }

  }

  static getInitialState() {
    const rdx: any = {};
    const initialState = {
      rdx: rdx
    };
    initialState.rdx[Rdx.Keys.TEST1] = "test1";
    return initialState;
  }

  static getNextComponentId() {
    return "component_" + nextId++;
  }

  static getNextId() {
    return nextId++;
  }

  static getValue(state: any, key: string) {
    if (!state && Rdx.store) {
      state = Rdx.store.getState();
    }
    return Rdx.Selectors.getValue(state,"rdx",key);
  }

  static resetAll(store: any) {
    const action = Rdx.Actions.resetAll();
    if (!store) store = Rdx.store;
    store.dispatch(action);
  }

  static setValue(component: any, key: string, value: any) {
    const action = Rdx.Actions.setValue(key,value);
    if (!component && Rdx.store) {
      const dispatch = Rdx.store.dispatch;
      dispatch(action);
    } else {
      const dispatch = component.props.dispatch;
      dispatch(action);
    }
  }

}
